import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ICommodityByShipmentInitialState } from '../interfaces/ICommodityByShipment';
import { ICommodityByShipmentList } from '../../../api/commodity/interface';
import { commodityApi } from '../../../api/commodity/commodityApi';

export const fetchCommodityByShipment = createAsyncThunk(
    'fetchCommodityByShipment',
    async (
        { shipmentId }: { shipmentId: number | string },
        { rejectWithValue },
    ) => {
        try {
            const response = await commodityApi.fetchCommodityByShipment(
                shipmentId,
            );
            return response;
        } catch {
            return rejectWithValue('Error');
        }
    },
);

const initialState: ICommodityByShipmentInitialState = {
    loading: false,
    commodityList: [],
};

export const commodityByShipmentSlice = createSlice({
    name: 'fetchCommodityByShipment',
    initialState,
    reducers: {
        setCommodityList: (
            state,
            action: PayloadAction<ICommodityByShipmentList[]>,
        ) => {
            state.commodityList = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchCommodityByShipment.pending, state => {
            state.loading = true;
            state.commodityList = [];
        });
        builder.addCase(fetchCommodityByShipment.fulfilled, (state, action) => {
            state.loading = false;
            state.commodityList = action.payload;
        });
        builder.addCase(fetchCommodityByShipment.rejected, state => {
            state.loading = false;
        });
    },
});

export const { setCommodityList } = commodityByShipmentSlice.actions;

const CommodityByShipmentReducer = commodityByShipmentSlice.reducer;
export default CommodityByShipmentReducer;
